(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["al-anfar-scent-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('al-anfar-scent-explorer')) {
    customElements.define('al-anfar-scent-explorer', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-scent-tab]')];
        this.panels = [...this.querySelectorAll('[data-scent-panel]')];
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab));
          tab.addEventListener('keydown', (event) => this.handleTabKeydown(event, tab));
        });
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.revealTimers = new Map();
        this.querySelectorAll('[data-scent-rail-shell]').forEach((shell) => this.setupRail(shell));
        this.querySelectorAll('[data-scent-accordion]').forEach((details) => {
          const summary = details.querySelector('.aa-scent__summary');
          summary?.addEventListener('click', (event) => {
            const expand = details.dataset.expanded !== 'true';
            this.setAccordion(details, expand);
          });
        });

        const revealVisibleCards = () => {
          const activePanel = this.panels.find((panel) => !panel.hidden);
          const activeAccordion = this.querySelector('[data-scent-accordion][data-expanded="true"]');
          this.revealCards(window.matchMedia('(min-width: 750px)').matches ? activePanel : activeAccordion);
        };

        if ('IntersectionObserver' in window) {
          this.stageObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) revealVisibleCards();
            });
          }, { threshold: .28 });
          this.stageObserver.observe(this);
        } else {
          requestAnimationFrame(revealVisibleCards);
        }
      }

      disconnectedCallback() {
        this.stageObserver?.disconnect();
        this.revealTimers?.forEach((timer) => clearTimeout(timer));
        this.querySelectorAll('[data-scent-rail]').forEach((rail) => cancelAnimationFrame(rail.aaTravelFrame));
      }

      setupRail(shell) {
        const rail = shell.querySelector('[data-scent-rail]');
        const previous = shell.querySelector('[data-scent-previous]');
        const next = shell.querySelector('[data-scent-next]');
        if (!rail || !previous || !next) return;

        const update = () => {
          const cards = [...rail.querySelectorAll('.aa-scent__card')];
          const cardWidth = cards[0]?.getBoundingClientRect().width || 0;
          const gap = Number.parseFloat(getComputedStyle(rail).columnGap) || 0;

          if (cardWidth > 0 && window.matchMedia('(min-width: 750px)').matches) {
            const visibleCount = Math.min(
              cards.length,
              Math.max(1, Math.floor((rail.clientWidth + gap) / (cardWidth + gap)))
            );
            const occupiedWidth = (visibleCount * cardWidth) + ((visibleCount - 1) * gap);
            const edgeSpace = Math.max(1, (rail.clientWidth - occupiedWidth) / 2);
            rail.style.setProperty('--aa-scent-edge-space', `${edgeSpace.toFixed(2)}px`);
          } else {
            rail.style.removeProperty('--aa-scent-edge-space');
          }

          const max = rail.scrollWidth - rail.clientWidth;
          const scrollable = max > 2;
          shell.classList.toggle('is-at-start', !scrollable || rail.scrollLeft <= 2);
          shell.classList.toggle('is-scrollable', scrollable);
          shell.classList.toggle('is-at-end', !scrollable || rail.scrollLeft >= max - 2);
          previous.disabled = !scrollable || rail.scrollLeft <= 2;
          next.disabled = !scrollable || rail.scrollLeft >= max - 2;
        };
        const move = (direction) => {
          const card = rail.querySelector('.aa-scent__card');
          const gap = Number.parseFloat(getComputedStyle(rail).columnGap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * .75;
          const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
          const target = Math.min(maximum, Math.max(0, rail.scrollLeft + (direction * distance)));
          this.travelRail(rail, target);
        };

        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        rail.addEventListener('scroll', update, { passive: true });
        const observer = new ResizeObserver(update);
        observer.observe(rail);
        requestAnimationFrame(update);
      }

      travelRail(rail, target) {
        cancelAnimationFrame(rail.aaTravelFrame);
        const start = rail.scrollLeft;
        const distance = target - start;
        if (this.reducedMotion.matches || Math.abs(distance) < 2) {
          rail.scrollLeft = target;
          return;
        }

        const startedAt = performance.now();
        const duration = 300;
        const tick = (time) => {
          const progress = Math.min(1, (time - startedAt) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          rail.scrollLeft = start + (distance * eased);
          if (progress < 1) rail.aaTravelFrame = requestAnimationFrame(tick);
        };
        rail.aaTravelFrame = requestAnimationFrame(tick);
      }

      setAccordion(details, expand) {
        const content = details.querySelector('[data-scent-content]');
        const summary = details.querySelector('.aa-scent__summary');
        if (!content) return;
        details.dataset.expanded = expand ? 'true' : 'false';
        summary?.setAttribute('aria-expanded', expand ? 'true' : 'false');

        if (expand) {
          this.querySelectorAll('[data-scent-accordion]').forEach((other) => {
            if (other !== details && other.dataset.expanded === 'true') this.setAccordion(other, false);
          });
          details.classList.add('is-open');
        }

        content.getAnimations().forEach((animation) => animation.cancel());
        const startHeight = content.getBoundingClientRect().height;
        const endHeight = expand ? content.scrollHeight : 0;

        if (this.reducedMotion.matches) {
          content.style.height = expand ? 'auto' : '0px';
          content.style.opacity = expand ? '1' : '0';
          if (!expand) details.classList.remove('is-open');
          return;
        }

        const animation = content.animate(
          [
            { height: `${startHeight}px`, opacity: expand ? Math.min(1, startHeight / Math.max(endHeight, 1)) : 1 },
            { height: `${endHeight}px`, opacity: expand ? 1 : 0 }
          ],
          { duration: expand ? 320 : 240, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'forwards' }
        );

        if (expand) this.revealCards(details);
        animation.onfinish = () => {
          content.style.height = expand ? 'auto' : '0px';
          content.style.opacity = expand ? '1' : '0';
          animation.cancel();
          if (!expand && details.dataset.expanded === 'false') details.classList.remove('is-open');
        };
      }

      revealCards(host) {
        if (!host) return;
        const cards = [...host.querySelectorAll('.aa-scent__card')];
        if (!cards.length || this.reducedMotion.matches) return;

        clearTimeout(this.revealTimers.get(host));
        host.classList.remove('is-revealing');
        host.classList.add('aa-scent__reveal-host');
        cards.forEach((card, index) => card.style.setProperty('--aa-scent-card-order', index));
        void host.offsetWidth;
        host.classList.add('is-revealing');

        const totalDuration = 360 + ((cards.length - 1) * 70);
        this.revealTimers.set(host, setTimeout(() => {
          host.classList.remove('is-revealing');
          this.revealTimers.delete(host);
        }, totalDuration + 40));
      }

      selectTab(selected) {
        this.tabs.forEach((tab) => {
          const active = tab === selected;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          const active = panel.dataset.scentPanel === selected.dataset.scentTab;
          if (!active) {
            panel.hidden = true;
            panel.classList.remove('is-entering');
            return;
          }

          const wasHidden = panel.hidden;
          panel.hidden = false;
          if (wasHidden) {
            this.revealCards(panel);
          }
        });
      }

      handleTabKeydown(event, current) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let index = this.tabs.indexOf(current);
        if (event.key === 'ArrowRight') index = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') index = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.tabs.length - 1;
        this.selectTab(this.tabs[index]);
        this.tabs[index].focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
